import React, { useState, useContext, useEffect, useRef } from 'react';
import './Handling.scss';
import VideoSimple from '@/v2/components/media/video/VideoSimple';
import TimelineText from '@/v2/components/atoms/TimelineText';
import TapDark from '@/v2/components/atoms/Icon/TapDark';
import TextBottom from '@/v2/components/atoms/TextBottom';
import Header from '@/v2/components/application/Header';
import Disclaimer from '@/v2/components/layouts/Disclaimer';
import { PerformanceContext } from '@/v2/state/providers';
import { MomentStateContext } from '@/v2/state/momentState';
import Button from '@/v2/components/atoms/Button';
import { timeout, clearTimeouts } from '@/v2/components/utils/Timeout';

let activated = false;
let videoController = null;

const videoReady = (controller, onReady, setTime) => {
    videoController = controller;
    videoController.video.addEventListener('timeupdate', () => {
        setTime(videoController.GetTime());
    });

    onReady();
};

const play = () => {
    videoController.Play();
};

const activate = () => {
    if (activated) return;
    activated = true;
    play();
};

export default ({ isActive, data, onFinished, onReady }) => {
    const [videoFinished, setVideoFinished] = useState(false);
    const [{ disclaimer }] = useContext(PerformanceContext);
    const [paused, setPaused] = useState(true);
    const [stopped, setStopped] = useState(true);
    const [animate, setAnimate] = useState('in');
    const { dispatch: momentDispatch } = useContext(MomentStateContext);

    const time = useRef(TimelineText.Time());

    const finishVideo = () => {
        setTimeout(() => {
            onFinished();
        }, 800);
    };

    useEffect(() => () => clearTimeouts(), []);

    useEffect(() => {
        if (isActive && videoController) {
            videoController.ProgressDispatch(momentDispatch);
            activate();
        }
    }, [isActive, videoController]);

    const options = {
        bufferBeforePlay: true,
        onReady: (controller) => videoReady(controller, onReady, time.current.Set),
        autoPlay: true,
        onFinished: () => {
            setVideoFinished(true);
        },
        playbackRate: 1.3,
    };

    if (videoFinished) {
        timeout(() => {
            setPaused(false);
            setStopped(false);
        }, 700);
    }

    const headerContent = <Header show={isActive} hideLogo dark />;
    const disclaimerContent = isActive && disclaimer ? <Disclaimer data={disclaimer} dark /> : '';

    const touchIndicator = () => {
        setAnimate('out');
        finishVideo(onFinished);
    };

    const timeLineText = isActive ? <TimelineText data={data.text.timeline} time={time.current} background="dark" color="black" /> : '';

    return (
        <div className="Handling">
            <VideoSimple src={data.video} options={options} />
            {headerContent}
            {timeLineText}
            {videoFinished && (
                <div className="Handling__text">
                    <TextBottom background="dark" animate={animate} color="black" component="h4">
                        <Button onClick={touchIndicator}>{data.text.cta.proceed}</Button>
                        <i className="icon">
                            <TapDark loop={false} isstopped={stopped} ispaused={paused} />
                        </i>
                    </TextBottom>
                </div>
            )}
            {disclaimerContent}
        </div>
    );
};
